/**
 * Phase C (audit v92) — Dashboard banner for pending coach proposals.
 *
 * Thin wrapper around GoalProposalCard that pulls from useGoalInbox.
 * Renders nothing when no pending proposals (silent default).
 *
 * Multiple proposals supported — vertical stack. In practice there's
 * usually 0 or 1 — coaches don't spam proposals.
 */
import { useGoalInbox } from "../goalApi";
import { GoalProposalCard } from "./GoalProposalCard";

export function GoalProposalBanner() {
  const { data, isLoading } = useGoalInbox();
  if (isLoading || !data || data.items.length === 0) return null;

  return (
    <div className="space-y-3">
      {data.items.map((item) => (
        <GoalProposalCard key={item.id} proposal={item} />
      ))}
    </div>
  );
}
